import { render } from "./UniversalPdfImageRow.vue?vue&type=template&id=e2d84da8&scoped=true&ts=true"
import script from "./UniversalPdfImageRow.vue?vue&type=script&lang=ts"
export * from "./UniversalPdfImageRow.vue?vue&type=script&lang=ts"

import "./UniversalPdfImageRow.vue?vue&type=style&index=0&id=e2d84da8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d84da8"]])

export default __exports__